// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import styled from '@emotion/styled';
import format from 'date-fns/format';

import { BlogPostCard_post } from '@zego-types/BlogPostCard_post.graphql';
import { BREAKPOINTS, getColorTint, unit, white } from '@zego/theme';

import H3 from '@zego/components/atoms/H3';
import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import Link from '@zego/components/Link';
import UploadedBackgroundImage from '@zego/components/UploadedBackgroundImage';

interface BlogPostCardProps {
  post: BlogPostCard_post & { publicationDate: string };
}

function BlogPostCard({
  post: { title, publicationDate, slug, coverImage },
}: BlogPostCardProps): JSX.Element {
  return (
    <article>
      <LinkContainer href={`/blog/${slug}`}>
        {coverImage && (
          <CardImage
            src={coverImage}
            alt=""
            imgixParams={{
              fit: 'crop',
              crop: 'edges',
            }}
          />
        )}
        <BlogInfo>
          <header>
            <BlogTitle>{title}</BlogTitle>
          </header>
          <Spacer height={unit(2)} />
          <footer>
            <PublishDate dateTime={publicationDate}>
              {format(publicationDate, 'DD MMMM YYYY')}
            </PublishDate>
          </footer>
        </BlogInfo>
      </LinkContainer>
    </article>
  );
}

/**
 * Styled components
 */

const LinkContainer = styled(Link)({
  display: 'flex',
  flexDirection: 'column',
  lineHeight: 0,
  height: '100%',
  borderRadius: 6,
  transition: `box-shadow 0.2s ease-in-out`,
  ':hover': {
    boxShadow: `0 0 ${unit(4)}px -4px rgba(0,0,0,0.125)`,
  },
});

const CardImage = styled(UploadedBackgroundImage)({
  width: '100%',
  height: `${unit(30)}px`,
  borderRadius: '6px 6px 0 0',
  backgroundColor: white,
  maxHeight: `${unit(25)}px`,
  [BREAKPOINTS.medium]: {
    maxHeight: `${unit(30)}px`,
  },
});

const BlogInfo = styled(View)({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: unit(2),
  backgroundColor: white,
  borderRadius: '0 0 6px 6px',
});

const BlogTitle = styled(H3)({
  fontSize: 22,
  color: getColorTint('grey', 10),
  [BREAKPOINTS.medium]: {
    fontSize: 22,
    lineHeight: '27px',
  },
});

const PublishDate = styled('time')({
  fontSize: 16,
  color: getColorTint('grey', 8),
  lineHeight: `${unit(3)}px`,
});

/**
 * Data export
 */

export default createFragmentContainer(BlogPostCard, {
  post: graphql`
    fragment BlogPostCard_post on BlogPost {
      title
      publicationDate
      slug
      coverImage
    }
  `,
});
